import React from "react";
import About1 from "../About/About1";

import WhyChoose from "../Home/WhyChoose";
import Ourservices from "../About/Ourservices";
import SEOHead from "../../components/SEOHead";

function About() {
  return (
    <div>
      <SEOHead />
      <About1 />
      <WhyChoose />
      <Ourservices />
    </div>
  );
}

export default About;
